import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';

// TYPES

// CSS
import styles from '@UILayer/UILayer.scss';

//BUTTONS
import { AutoButton, AutoTurboButton, BigMultiButton, GambleButton, TakeButton } from '@UILayer/Buttons';

// REDUX
import { getAccount, getBonusBuy, getButtonState, getDeviceInfo, getGlobalStyles, getUIState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

//IMAGES
import blankImage from '@UILayer/Buttons/CommonImages/button_blank.svg';
import blankSmallHorizontal from '@UILayer/Buttons/CommonImages/button_small_horizontal_blank.svg';
import blankSmallVertical from '@UILayer/Buttons/CommonImages/button_small_vertical_blank.svg';

const GamePlayPanel: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { autoButton: boolean; bigWidth: number; uiFreeze: boolean }, newState: any) => ({ ...state, ...newState }), {
        autoButton: true,
        bigWidth: 0,
        uiFreeze: false
    });

    const gameStoreAccount = useAppSelector(getAccount);
    const gameStoreButtonState = useAppSelector(getButtonState);
    const device = useAppSelector(getDeviceInfo);
    const globalStyles = useAppSelector(getGlobalStyles);
    const uiState = useAppSelector(getUIState);
    const bonusBuyState = useAppSelector(getBonusBuy);

    const classes = cn(
        styles.gamePlayPanel,
        globalStyles.screenSize,
        globalStyles.handMode,
        globalStyles.device,
        globalStyles.orientation,
        globalStyles.isTablet,
        bonusBuyState.isDialogOpen && styles.hide
    );

    const blankImagesSrc = device.windowOrientationHorizontal ? blankSmallVertical : blankSmallHorizontal;

    useEffect(() => {
        setState({ autoButton: gameStoreButtonState?.isAutoButtonActive || gameStoreAccount.bonuses.freeSpins ? true : false });
    }, [gameStoreAccount, gameStoreButtonState]);

    useEffect(() => {
        setState({ uiFreeze: uiState.uiFreeze });
    }, [uiState.uiFreeze]);
    return (
        <>
            <div className={classes}>
                <div className={styles.gamePlayPanel_button_group_small}>
                    {state.autoButton && <AutoButton uiFreeze={state.uiFreeze} />}
                    {gameStoreButtonState?.isGambleButtonActive && <GambleButton uiFreeze={state.uiFreeze} />}
                    <img className={styles.button_small_blank_image} src={blankImagesSrc} alt="" aria-hidden={true} />
                </div>
                <div className={styles.gamePlayPanel_button_group}>
                    <BigMultiButton uiFreeze={state.uiFreeze} />
                    <img className={styles.button_blank_image} src={blankImage} alt="" aria-hidden={true} />
                </div>
                <div className={styles.gamePlayPanel_button_group_small}>
                    {gameStoreButtonState?.isTakeButtonActive && <TakeButton uiFreeze={state.uiFreeze} />}
                    {!gameStoreButtonState?.isTakeButtonActive && gameStoreButtonState?.isTurboButtonActive && <AutoTurboButton uiFreeze={state.uiFreeze} />}
                    <img className={styles.button_small_blank_image} src={blankImagesSrc} alt="" aria-hidden={true} />
                </div>
            </div>
        </>
    );
};

export default GamePlayPanel;
